module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAKtJREFUWEfd18EOgCAMA9Dty4Uvx0A8GA/K2k6iXDxI0pcOEnVbvHxxvv0T0ForvVl3H8+7JW/gCN/MrL4OiIaPlp4qmn2PhMsAaLgEwITTADacApzCi7vX2bNy3QcdQlU41IAyPAxQzBweQUb4dANZ4d8BdGlWC6FrmIEIATKaCAPUCAigRMAAFYICKBA0gEVIAAxCBkARUgCCkANOiDU/JtFPs5QGIojlgB02u4AhUgiaGQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/left_1.png
// module id = zbof
// module chunks = 1